<app-simple-multiple-search-select-value-accessor label="Stany spraw"
                                                  [formControl]="stateForm"
                                                  [data]="states">
</app-simple-multiple-search-select-value-accessor>